import { Command, Extension } from '@tiptap/core';
import { TextSelection, NodeSelection } from 'prosemirror-state';

const setAlignment = (align: 'left' | 'center' | 'right' | 'justify'): Command => {
  return ({ state, dispatch }) => {
    const { tr, selection, doc } = state;
    const { from, to } = selection;

    const selectionRange = { from, to };
    let isSingleMediaSelected = false;

    // Common array for media-like block nodes (images and iframes)
    const mediaNodes = ['image', 'iframe'];
    const textNodes = ['paragraph', 'heading'];

    state.doc.nodesBetween(from, to, (node, pos) => {
      const nodeType = node.type.name;

      if (textNodes.includes(nodeType)) {
        tr.setNodeMarkup(pos, undefined, {
          ...node.attrs,
          textAlign: align,
        });
      }

      if (mediaNodes.includes(nodeType) && align!=='justify') {
        tr.setNodeMarkup(pos, undefined, {
          ...node.attrs,
          align,
        });

        // Check if the selection only contains the media node
        if (from === pos && to === pos + node.nodeSize) {
          isSingleMediaSelected = true;
        }
      }
    });

    if (tr.docChanged && dispatch) {
      let newSelection;

      if (isSingleMediaSelected) {
        // Re-select the media node itself (image or iframe)
        newSelection = NodeSelection.create(tr.doc, from);
      } else {
        // Restore the original text selection
        const resolvedFrom = tr.doc.resolve(selectionRange.from);
        const resolvedTo = tr.doc.resolve(selectionRange.to);
        newSelection = TextSelection.create(tr.doc, resolvedFrom.pos, resolvedTo.pos);
      }

      tr.setSelection(newSelection as any);
      dispatch(tr);
      return true;
    }

    return false;
  };
};

export const CustomAlignment = Extension.create({
  name: 'customAlignment',

  addCommands() {
    return {
      setAlignment,
    };
  },
});
